import { animate, state, style, transition, trigger } from '@angular/animations';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { booleanAttribute, Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'glxy-nav-item-list',
  templateUrl: './nav-item-list.component.html',
  styleUrls: ['./nav-item-list.component.scss'],
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          height: '*',
          opacity: 1,
        }),
      ),
      state(
        'closed',
        style({
          height: '0px',
          opacity: 0,
        }),
      ),
      transition('* => *', [animate('0.2s')]),
    ]),
  ],
  standalone: false,
})
export class GalaxyNavItemListComponent extends CdkAccordionItem implements OnInit {
  @HostBinding('class') class = 'glxy-nav-item-list';

  /** Material icon name, or custom SVG icon **/
  @Input() icon?: string;

  /** If your icon is a custom SVG **/
  @Input({ transform: booleanAttribute }) isSvg = false;

  /** Should the submenu start in the expanded state or not **/
  @Input({ transform: booleanAttribute }) startExpanded = false;

  ngOnInit(): void {
    super.ngOnInit();
    this.expanded = this.startExpanded;
  }
}
